enum GCPaymentProvider {
	Stripe = "Stripe",
	PayPalJsSdk = "PayPalJsSdk",
	Klarna = "Klarna",
	AfterpayClearpay = "AfterpayClearpay"
}

export default GCPaymentProvider;
